var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMmsBlister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 140,
    viewBox: "0 0 123 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.6625,
    y: 0.426609,
    width: 55.5623,
    height: 107.994,
    rx: 5.86926,
    transform: "rotate(5.43876 66.6625 0.426609)",
    fill: "#E3E3E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6625,
    y: 0.426609,
    width: 55.5623,
    height: 107.994,
    rx: 5.86926,
    transform: "rotate(5.43876 66.6625 0.426609)",
    stroke: "#BCBCBC",
    strokeWidth: 0.782568
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.1255 16.3222C88.7978 19.7642 85.7418 22.2889 82.2998 21.9612C78.8577 21.6334 76.3331 18.5774 76.6608 15.1354C76.9885 11.6934 80.0445 9.16871 83.4865 9.49643C86.9286 9.82415 89.4532 12.8801 89.1255 16.3222Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1968 36.5774C86.8691 40.0194 83.8131 42.5441 80.3711 42.2163C76.929 41.8886 74.4044 38.8326 74.7321 35.3906C75.0598 31.9485 78.1158 29.4239 81.5578 29.7516C84.9999 30.0793 87.5245 33.1353 87.1968 36.5774Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2681 56.8325C84.9404 60.2746 81.8844 62.7992 78.4424 62.4715C75.0003 62.1438 72.4757 59.0878 72.8034 55.6458C73.1311 52.2037 76.1871 49.6791 79.6291 50.0068C83.0712 50.3345 85.5958 53.3905 85.2681 56.8325Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3399 77.0877C83.0122 80.5297 79.9562 83.0544 76.5141 82.7267C73.0721 82.399 70.5474 79.343 70.8752 75.9009C71.2029 72.4589 74.2589 69.9342 77.7009 70.262C81.1429 70.5897 83.6676 73.6457 83.3399 77.0877Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4112 97.3429C81.0835 100.785 78.0275 103.31 74.5854 102.982C71.1434 102.654 68.6187 99.5981 68.9464 96.1561C69.2742 92.7141 72.3302 90.1894 75.7722 90.5171C79.2142 90.8448 81.7389 93.9008 81.4112 97.3429Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.38 18.2507C109.053 21.6927 105.997 24.2174 102.555 23.8897C99.1126 23.5619 96.588 20.5059 96.9157 17.0639C97.2434 13.6219 100.299 11.0972 103.741 11.4249C107.183 11.7527 109.708 14.8086 109.38 18.2507Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.452 38.5059C107.124 41.9479 104.068 44.4725 100.626 44.1448C97.1844 43.8171 94.6597 40.7611 94.9875 37.3191C95.3152 33.877 98.3712 31.3524 101.813 31.6801C105.255 32.0078 107.78 35.0638 107.452 38.5059Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.523 58.761C105.196 62.2031 102.14 64.7277 98.6977 64.4C95.2557 64.0723 92.731 61.0163 93.0588 57.5743C93.3865 54.1322 96.4425 51.6076 99.8845 51.9353C103.327 52.263 105.851 55.319 105.523 58.761Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.595 79.0162C103.267 82.4582 100.211 84.9829 96.769 84.6552C93.327 84.3275 90.8023 81.2715 91.13 77.8294C91.4578 74.3874 94.5137 71.8627 97.9558 72.1905C101.398 72.5182 103.922 75.5742 103.595 79.0162Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101.667 99.2714C101.339 102.713 98.2828 105.238 94.8408 104.91C91.3988 104.583 88.8741 101.527 89.2018 98.0846C89.5295 94.6426 92.5855 92.1179 96.0276 92.4456C99.4696 92.7733 101.994 95.8293 101.667 99.2714Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_202)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 36.6353,
    width: 56.3449,
    height: 108.777,
    rx: 6.26055,
    transform: "rotate(-18.2394 0 36.6353)",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4495 42.4208C28.5317 45.7047 26.7469 49.2441 23.463 50.3263C20.1791 51.4085 16.6397 49.6236 15.5575 46.3397C14.4753 43.0559 16.2602 39.5165 19.544 38.4343C22.8279 37.3521 26.3673 39.1369 27.4495 42.4208Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8177 61.7453C34.8999 65.0292 33.115 68.5686 29.8312 69.6508C26.5473 70.7329 23.0079 68.9481 21.9257 65.6642C20.8435 62.3804 22.6283 58.841 25.9122 57.7588C29.1961 56.6766 32.7355 58.4614 33.8177 61.7453Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1863 81.0698C41.2685 84.3537 39.4837 87.8931 36.1998 88.9753C32.9159 90.0574 29.3765 88.2726 28.2943 84.9887C27.2122 81.7048 28.997 78.1654 32.2809 77.0833C35.5647 76.0011 39.1041 77.7859 40.1863 81.0698Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5545 100.394C47.6367 103.678 45.8519 107.218 42.568 108.3C39.2841 109.382 35.7447 107.597 34.6625 104.313C33.5803 101.029 35.3651 97.4899 38.649 96.4078C41.9329 95.3256 45.4723 97.1104 46.5545 100.394Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9227 119.719C54.0049 123.003 52.22 126.542 48.9361 127.624C45.6523 128.706 42.1129 126.922 41.0307 123.638C39.9485 120.354 41.7333 116.814 45.0172 115.732C48.3011 114.65 51.8405 116.435 52.9227 119.719Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7742 36.0525C47.8564 39.3364 46.0716 42.8758 42.7877 43.958C39.5038 45.0402 35.9644 43.2553 34.8822 39.9715C33.8 36.6876 35.5849 33.1482 38.8688 32.066C42.1526 30.9838 45.692 32.7686 46.7742 36.0525Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1424 55.377C54.2246 58.6609 52.4397 62.2003 49.1559 63.2825C45.872 64.3647 42.3326 62.5798 41.2504 59.296C40.1682 56.0121 41.953 52.4727 45.2369 51.3905C48.5208 50.3083 52.0602 52.0931 53.1424 55.377Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5106 74.7015C60.5927 77.9854 58.8079 81.5248 55.524 82.607C52.2401 83.6892 48.7007 81.9043 47.6186 78.6204C46.5364 75.3366 48.3212 71.7972 51.6051 70.715C54.889 69.6328 58.4284 71.4176 59.5106 74.7015Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8787 94.026C66.9609 97.3099 65.1761 100.849 61.8922 101.931C58.6083 103.014 55.0689 101.229 53.9867 97.9449C52.9045 94.6611 54.6894 91.1217 57.9732 90.0395C61.2571 88.9573 64.7965 90.7421 65.8787 94.026Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2474 113.35C73.3296 116.634 71.5447 120.174 68.2608 121.256C64.977 122.338 61.4376 120.553 60.3554 117.269C59.2732 113.986 61.058 110.446 64.3419 109.364C67.6258 108.282 71.1652 110.067 72.2474 113.35Z",
    fill: "#E7CCCF",
    strokeWidth: 1.56514,
    stroke: "#BCBCBC"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.494092,
    y: 36.8844,
    width: 55.5623,
    height: 107.994,
    rx: 5.86926,
    transform: "rotate(-18.2394 0.494092 36.8844)",
    stroke: "#BCBCBC",
    strokeWidth: 0.782568
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_202"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 36.6353,
    width: 56.3449,
    height: 108.777,
    rx: 6.26055,
    transform: "rotate(-18.2394 0 36.6353)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmsBlister);
export default __webpack_public_path__ + "static/media/mms-blister.9d00e5d80ae48fd63124b43b68edf4f2.svg";
export { ForwardRef as ReactComponent };